import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DinamicoService } from '../../service/dinamico.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor(private dinamicoService: DinamicoService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const countryCode = this.dinamicoService.getPrefijo().trim().toUpperCase();    
    
    // Clonar la solicitud y agregar el header
    const requestWithTenant = request.clone({
      setHeaders: {
        'x-kaufmann-tenant': countryCode
      }
    });

    return next.handle(requestWithTenant);
  }
}
